import {AuthGuard} from '../../shared/guards/AuthGuard';
import {ListagemRelatoriosPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const ListagemRelatoriosPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <ListagemRelatoriosPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};